import { render } from "./TopCatogery.vue?vue&type=template&id=133c643e&scoped=true"
import script from "./TopCatogery.vue?vue&type=script&lang=js"
export * from "./TopCatogery.vue?vue&type=script&lang=js"

import "./TopCatogery.vue?vue&type=style&index=0&id=133c643e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133c643e"]])

export default __exports__